import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { doLogOut, getWhoAmI } from '../auth/authActions'
import { getUserDto, hasAnyRole, isAuthenticated, getUserCompanies, hasRoleInCompany } from '../auth/authSelectors'
import { getCurrentRoute } from './RouterSelector'
import { IDispatchProps, IStateProps, Routes } from './Routes'
import { CompanyId, Role } from '../../services/api.types'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  hasAnyRole: (roles: Role[]) => hasAnyRole(state, roles),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  authenticated: isAuthenticated(state),
  currentRoute: getCurrentRoute(state),
  userDto: getUserDto(state),
  userCompanies: getUserCompanies(state),
})

const mapDispatchToProps: IDispatchProps = {
  doLogOut,
  getWhoAmI,
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes)
